const styles = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  panelBorderColor: 'rgba(0,0,0,0.2)',
  leftDrawer: {
    overlayColor: 'rgba(255,255,255,0.6)',
    drawerStyle: {
      background: '#F9F9F9',
      boxShadow: 'rgba(0, 0, 0, 0.188235) 0px 10px 20px, rgba(0, 0, 0, 0.227451) 0px 6px 6px',
    },
  },
  rightDrawer: {
    overlayColor: 'rgba(255,255,255,0.6)',
    drawerStyle: {
      background: '#F9F9F9',
      boxShadow: 'rgba(0, 0, 0, 0.188235) 0px 10px 20px, rgba(0, 0, 0, 0.227451) 0px 6px 6px',
    },
  },
};

export default styles;



// WEBPACK FOOTER //
// ./src/containers/Editor/Editor.styles.js